import React from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';
import EmptyState from '../../../../components/EmptyState';
import { P } from '../../../../components/Typography';
import { Allow } from '../../../../auth/accessToken';
import { Discount } from '../../../../types/discounts';
import NoDiscounts from './NoDiscounts';

export interface ListMessageProps extends WithTranslation {
    discounts: Discount[];
    isLoading: boolean;
    isLoadingNext: boolean;
    accountId: string;
    customerId: string;
    hasNext: boolean;
}

const ListMessage = (
    {
        t,
        discounts,
        isLoading,
        isLoadingNext,
    }: ListMessageProps
) => {
    if (isLoading || isLoadingNext) {
        return null;
    }
    if (!isLoading && discounts.length === 0) {
        return (
            <Allow
                anyOfScopes={[['admin'], ['admin:accounts'], ['write:accounts', 'read:accounts'], ['accounts:admin']]}
                fallback={
                    <EmptyState>
                        <P>{t('customers.customer.discounts.no_discounts.body')}</P>
                    </EmptyState>
                }
            >
                <NoDiscounts />
            </Allow>
        );
    }

    return null;
};

export default withTranslation()(ListMessage);
